<ac-layer acFor="let entity of entities$" [context]="this">
    <ac-html-desc props="{position: entity.position, show: entity.show}">
        <ng-template let-entity>
            <div class="contianer">
                <div>
                    <mat-icon (click)="showDatos(entity)" matTooltip="Click to show data" matTooltipPosition="right">dvr</mat-icon>
                    <br> {{entity.name}}
                </div>
                <div>

                </div>
            </div>
        </ng-template>
    </ac-html-desc>
</ac-layer>
<div class="tipo-dato-btn">
    <button mat-raised-button color="primary" (click)="openTipoDatosModal()">Seleccionar Tipos Dato</button>
</div>